import type {
    IsoAndUnixTimestamp} from "@@/shared/date-time/iso-and-unix";
import {
    isoAndUnixZodSchema,
} from "@@/shared/date-time/iso-and-unix";
import { z } from "zod";
import type {
    PayoutTargetId} from "../../financials/payout-targets/payout-target-id";
import {
    payoutTargetIdZodSchema,
} from "../../financials/payout-targets/payout-target-id";
import type {
    CompanyDetailsId} from "./company-details-id";
import {
    companyDetailsIdZodSchema,
} from "./company-details-id";

type _CompanyDetailsBase = {
    readonly _id: CompanyDetailsId;
    readonly _type: "COMPANY_DETAILS";
    readonly _createdAt: IsoAndUnixTimestamp;
    readonly name: string;
    /**
     * Payout Targets, default payout target is the first one in the list
     */
    readonly payoutTargetIds: PayoutTargetId[];
};

const companyDetailsBaseZodSchema: z.ZodSchema<_CompanyDetailsBase> = z.object({
    _id: companyDetailsIdZodSchema,
    _type: z.literal("COMPANY_DETAILS"),
    _createdAt: isoAndUnixZodSchema,
    name: z.string().min(1),
    payoutTargetIds: z.array(payoutTargetIdZodSchema),
});

export { companyDetailsBaseZodSchema };
export type { _CompanyDetailsBase };
